<app-topnav></app-topnav>

<form [formGroup]="blogForm">

    <div class="top-main-wrapper">

        <div class="dash-header">
            <div class="dash-title">

                <div class="p-field p-grid">
                    <div class="p-col-8 p-md-8" *ngIf="element">
                        <h3>Startup <span class="normal-font" *ngIf="element.id">/ {{tourTitle}}</span> </h3>


                    </div>
                    <div class="p-col-4 p-md-4">
                        <button pButton pRipple [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-save'"
                            [label]="isSaving ? 'salvataggio…' : 'salva'"
                            class="p-button pull-right p-button-success p-mr-2" (click)="onSubmit()"
                            [disabled]="!blogForm.valid || isSaving"></button>


                        <button type="button" pButton pRipple icon="pi pi-chevron-left" label=" indietro"
                            class="p-button p-button-back pull-right  p-mr-2"
                            (click)="goBack()"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="main-inner">

        <div *ngIf="loadingPage" class="p-text-center p-p-4">
            <span class="pi pi-spin pi-spinner" style="font-size: 2rem;"></span>
            <p class="small">Caricamento…</p>
        </div>

        <div class="p-fluid">
            <div class="p-field p-grid">




                <div class="p-col-12 p-md-12">


                    <p-tabs [value]="0">
                        <p-tablist>
                            <p-tab [value]="0">Informazioni</p-tab>
                            <p-tab [value]="1" *ngIf="element">Slideshow</p-tab>
                        </p-tablist>
                        <p-tabpanels>
                            <p-tabpanel [value]="0">
                                <div class="p-grid">

                                    <div class="p-col-12 p-md-8">
                                        <p-card>


                                            <div class="p-fluid">

                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Startup Name<span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="startup_name">

                                                        <!-- <input type="text" [style]="{ width: '100%' }" [(ngModel)]="data" value="{{rows.value | json}}" pInputText formControlName="data" >-->

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">

                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Startup Url<span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">
                                                        <p-inputgroup>

                                                            <input type="text" [style]="{ width: '100%' }" pInputText
                                                                formControlName="startup_url">

                                                            <button type="button" pButton pRipple label="website"
                                                                class="p-button p-button-success"
                                                                (click)="goToUrl()"></button>

                                                        </p-inputgroup>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Headline / Slogan <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="startup_headline">

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Country <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">
                                                        <p-select [options]="countriesList" [style]="{ width: '100%' }"
                                                            formControlName="country" optionLabel="label"
                                                            optionValue="label">
                                                        </p-select>


                                                    </div>
                                                </div>
                                            </div>
                                            <div class="p-field p-grid">
                                                <label class="p-col-12">Category <span class="required">*</span></label>
                                                <div class="p-col-12">

                                                    <p-multiSelect [options]="categoriesList" selectionLimit="3"
                                                        [style]="{ width: '100%' }" formControlName="markets"
                                                        optionLabel="category_name" optionValue="id">
                                                    </p-multiSelect>

                                                </div>
                                            </div>


                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Slug <span class="required"></span></label>
                                                    <div class="p-col-12">
                                                        <p-inputgroup>
                                                            <p-inputgroup-addon>startupinspire.com/startup/</p-inputgroup-addon>

                                                            <input type="text" pInputText formControlName="page_url">
                                                        </p-inputgroup>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">User ID <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="user_id">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Status <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="status">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12" for="startup-points">Points</label>
                                                    <div class="p-col-12">
                                                        <app-points-selector id="startup-points"
                                                            formControlName="points"></app-points-selector>
                                                        <small class="p-error"
                                                            *ngIf="blogForm.get('points')?.invalid && blogForm.get('points')?.touched">
                                                            Enter a whole number from 1 to 10.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Description <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">


                                                        <p-editor formControlName="startup_description"
                                                            [style]="{ height: '220px' }">
                                                            <ng-template pTemplate="header">
                                                                <span class="ql-formats">
                                                                    <button type="button" class="ql-bold"
                                                                        aria-label="Bold"></button>
                                                                    <button type="button" class="ql-italic"
                                                                        aria-label="Italic"></button>
                                                                    <button type="button" class="ql-underline"
                                                                        aria-label="Underline"></button>
                                                                    <button type="button" class="ql-clean"
                                                                        aria-label="clean">
                                                                    </button>

                                                                    <button type="button" class="ql-link"
                                                                        aria-label="Link">
                                                                    </button>
                                                                </span>
                                                            </ng-template>
                                                        </p-editor>



                                                    </div>
                                                </div>
                                            </div>


                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Technology Stack <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">



                                                        <p-multiSelect [options]="technologyList" selectionLimit="10"
                                                            [style]="{ width: '100%' }"
                                                            formControlName="startup_technology" optionLabel="title"
                                                            display="chip" optionValue="title">
                                                        </p-multiSelect>


                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Email <span class="required"></span></label>
                                                    <div class="p-col-12">
                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="startup_email">
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Linkedin <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="linkedin">

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Twitter <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="twitter">

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Producthunt <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="producthunt">

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="p-fluid">
                                                <div class="p-field p-grid">
                                                    <label class="p-col-12">Backlink URL <span
                                                            class="required"></span></label>
                                                    <div class="p-col-12">

                                                        <input type="text" [style]="{ width: '100%' }" pInputText
                                                            formControlName="backlink_url">

                                                    </div>
                                                </div>
                                            </div>





                                            <div class="form-group form-row">
                                                <label class="p-md-3"></label>
                                                <div class="p-md-9">
                                                    <input type="hidden" formControlName="id">
                                                    <input type="hidden" formControlName="user_id">

                                                </div>
                                            </div>

                                        </p-card>
                                    </div>



                                    <div class="p-col-12 p-md-4">

                                        <p-card *ngIf="hasDuplicates">
                                            <h3>Duplicate Url</h3>
                                            <div *ngFor=" let item of elementsUrl; let i = index">
                                                <div class="p-grid">
                                                    <div class="p-col-12 p-md-8">

                                                        {{item.startup_name}}
                                                        {{item.status}}
                                                        <p class="small truncate"> {{item.page_url}}</p>
                                                    </div>
                                                    <div class="p-col-12 p-md-4">

                                                        <button pButton pRipple label="view" icon="pi pi-eye"
                                                            class="p-button p-button-outline pull-right"
                                                            [routerLink]="['/admin/startups/edit', item.id]"></button>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>

                                        </p-card>

                                        <p-card *ngIf="!hasDuplicates">
                                            No duplicate URLs found.
                                        </p-card>
                                        <p-card>
                                            <div class="p-grid">
                                                <div class="p-col-12 p-md-12 p-mb-3">

                                                    <ng-container *ngIf="user">
                                                        <button pButton pRipple label="view" icon="pi pi-eye"
                                                            class="p-button p-button-outline pull-right"
                                                            [routerLink]="['/admin/users/edit', user.id]"></button>

                                                        <h4 class="p-pb-2 p-mb-0">{{user.display_name}}</h4>
                                                        <p class="small">{{user.user_email}}</p>

                                                    </ng-container>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="user">

                                                <p-tag class="cp p-mr-2" *ngIf="user.account_type == 2"
                                                    severity="default">Pro</p-tag>

                                                <p-tag *ngIf="user" class="cp p-mr-2" severity="success">ID
                                                    {{user.id}}</p-tag>
                                            </ng-container>
                                            <p-tag *ngIf="user" class="cp p-mr-2" severity="warning">Total Submission
                                                {{count}}</p-tag>

                                            <p-tag *ngIf="startupStatus == 1" class="cp" severity="success"
                                                (click)="unpublished(id)">published</p-tag>



                                            <p-tag *ngIf="startupStatus == 0" class="cp" severity="danger"
                                                (click)="published(id)">unpublished</p-tag>
                                        </p-card>

                                        <p-card *ngIf="element">
                                            <h4>Founders</h4>
                                            <div *ngIf="foundersLoading" class="small">
                                                <span class="pi pi-spin pi-spinner"></span> Loading...
                                            </div>
                                            <ng-container *ngIf="!foundersLoading">
                                                <div *ngIf="founders.length === 0" class="small">No founders linked.
                                                </div>
                                                <div *ngFor="let f of founders; let i = index">
                                                    <div class="p-grid">
                                                        <div class="p-col-12 p-md-8">
                                                            <h5 class="p-mb-0">{{ f.name }}</h5>
                                                            <p class="small p-mb-0" *ngIf="f.role">{{ f.role }}<span
                                                                    *ngIf="f.year"> · {{ f.year }}</span></p>
                                                            <p class="small truncate" *ngIf="f.headline">{{ f.headline
                                                                }}
                                                            </p>
                                                        </div>
                                                        <div class="p-col-12 p-md-4">
                                                            <button pButton pRipple icon="pi pi-pencil" label="edit"
                                                                class="p-button p-button-outline pull-right"
                                                                [routerLink]="['/admin/founders/edit', f.id]"></button>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                </div>
                                            </ng-container>
                                        </p-card>

                                        <p-card>
                                            <h4>Featured</h4>
                                            <p-select [options]="featuredOptions" [style]="{ width: '100%' }"
                                                formControlName="is_featured" optionLabel="label" optionValue="value">
                                            </p-select>


                                        </p-card>

                                        <p-card>
                                            <h4>Domain Rank</h4>
                                            <div *ngIf="domainRating?.loading">
                                                <span class="pi pi-spin pi-spinner"></span> Checking...
                                            </div>

                                            <ng-container *ngIf="!domainRating?.loading && domainRating">
                                                <div
                                                    *ngIf="domainRating.rating !== undefined && domainRating.rating !== null">
                                                    <div class="domain-rank-gauge"
                                                        style="position: relative; width: 80px; height: 80px; display: inline-block;">
                                                        <div [style.width.px]="80" [style.height.px]="80"
                                                            [style.border-radius]="'50%'"
                                                            [style.background]="getDomainRankGaugeBackground(domainRating.rating)"
                                                            [style.-webkit-mask]="'radial-gradient(farthest-side, transparent calc(100% - 8px), #000 calc(100% - 8px))'"
                                                            [style.mask]="'radial-gradient(farthest-side, transparent calc(100% - 8px), #000 calc(100% - 8px))'">
                                                        </div>
                                                        <span
                                                            style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; color: #333;">{{domainRating.rating}}</span>
                                                    </div>
                                                    <p class="small p-mt-2" *ngIf="domainRating.domain">
                                                        {{domainRating.domain}}
                                                        <span *ngIf="domainRating.source"> ·
                                                            {{domainRating.source}}</span>
                                                    </p>
                                                </div>
                                                <div *ngIf="domainRating.error" class="error">
                                                    Unable to retrieve domain rating.
                                                </div>
                                            </ng-container>
                                        </p-card>
                                        <p-card>
                                            <h4>Why is not published</h4>
                                            <p-select [options]="notesList" [style]="{ width: '100%' }"
                                                formControlName="notes" optionLabel="label" optionValue="label">
                                            </p-select>

                                            <button type="button" pButton class="p-button p-button-outline p-mt-2"
                                                label="Send Notes" (click)="sendNotes()"></button>


                                            <div class="p-field p-grid p-mt-2">
                                                <label class="p-col-12 p-mb-2">Data <span
                                                        class="required">*</span></label>
                                                <div class="p-col-12 p-md-12">

                                                    <p-datepicker formControlName="publish_date" dataType="string"
                                                        dateFormat="yy-mm-dd" />



                                                    <div *ngIf="publishDate?.errors?.required && publishDate?.touched"
                                                        class="error">
                                                        Date is required.
                                                    </div>
                                                    <div *ngIf="publishDate?.errors?.invalidDateTime && publishDate?.touched"
                                                        class="error">
                                                        Invalid date format. Expected format: YYYY-MM-DD.
                                                    </div>
                                                </div>
                                            </div>

                                        </p-card>
                                        <p-card>


                                            <ng-container *ngIf="element">
                                                <app-upload-single [element]="element.id"></app-upload-single>

                                            </ng-container>

                                        </p-card>
                                    </div>
                                </div>
                            </p-tabpanel>
                            <ng-container *ngIf="element">

                                <p-tabpanel [value]="1">
                                    <app-upload [element]="element"></app-upload>
                                </p-tabpanel>

                            </ng-container>
                        </p-tabpanels>


                    </p-tabs>



                </div>



            </div>

        </div>
    </div>
</form>




<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>

    <p-footer>
        <button type="button" pButton icon="fa fa-close" class="p-button p-button-danger p-mr-2" label="No"
            (click)="cd.reject()"></button>
        <button type="button" pButton icon="fa fa-check" class="p-button p-button-success p-mr-2" label="Si"
            (click)="cd.accept()"></button>
    </p-footer>

</p-confirmDialog>

<p-toast key="myKey1" position="bottom-right"></p-toast>
